import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import { AuthResponse } from '../interfaces/authUser';
import { Company } from '../interfaces/company';
import { UrlFactory } from '../utils/url-factory';

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	constructor(
		private _http: HttpClient,
		private _router: Router
	) {}

	login(body: FormData): Observable<AuthResponse> {
		const URL = UrlFactory.login();
		return this._http.post<AuthResponse>(URL, body).pipe(
			map((authResponse) => {
				this._saveToken(authResponse);
				return authResponse;
			})
		);
	}

	logout(): void {
		sessionStorage.removeItem('obd-token');
		this._router.navigate(['login']);
	}

	getToken(): string | null {
		const currentToken = sessionStorage.getItem('obd-token');
		return currentToken && currentToken.length > 0 ? currentToken : null;
	}

	isUserAdmin(): boolean {
		const userSettings = sessionStorage.getItem('obd-user');
		if (userSettings) {
			const parsedUserSettings = JSON.parse(userSettings);
			return parsedUserSettings.a_type;
		}
		return false;
	}

	isUserMinion(): boolean {
		const userSettings = sessionStorage.getItem('obd-user');
		if (userSettings) {
			const parsedUserSettings = JSON.parse(userSettings);
			return parsedUserSettings.minions;
		}
		return false;
	}

	getEmpresa(): Company | null {
		const currentCompany = sessionStorage.getItem('obd-company');
		if (currentCompany) {
			const parsedCompany = JSON.parse(currentCompany);
			return parsedCompany;
		}
		return null;
	}

	private _saveToken(authResponse: AuthResponse): void {
		sessionStorage.setItem('obd-token', authResponse.token);
		const userSettings = {
			a_type: authResponse.admin,
			minions: authResponse.minions,
			pkg: authResponse.pk
		};

		const companySettings = authResponse.empresa;
		sessionStorage.setItem('obd-user', JSON.stringify(userSettings));
		sessionStorage.setItem('obd-company', JSON.stringify(companySettings));
	}
}
